import { DialogConfig } from '@agent-ds/shared/components/dialog/dialog-config';
import { DialogRef } from '@agent-ds/shared/components/dialog/dialog-ref';
import { TableConfig } from '@agent-ds/shared/components/page-scroll-table/table-interface';
import { Contract } from '@agent-ds/shared/interfaces';
import { FormMeta } from '@agent-ds/shared/models';
import { SafeDatePipe } from '@agent-ds/shared/pipes/safe-date.pipe';
import { AfterViewInit, Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { CUSTOMER_PROGRESS_SK_INFO_DIALOG_CONTRACTS_TABLE_CONFIG } from './gyoseki-management-customer-progress-sk-info-dialog-config';
import * as _ from 'underscore';
import { DecimalPipe } from '@angular/common';

@Component({
  selector: 'ag-gyoseki-management-customer-progress-sk-info-dialog',
  templateUrl: './gyoseki-management-customer-progress-sk-info-dialog.component.html',
  styleUrls: ['./gyoseki-management-customer-progress-sk-info-dialog.component.scss'],
})
export class GyosekiManagementCustomerProgressSkInfoDialogComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('status', { static: false }) statusTemplate: TemplateRef<any>;
  @ViewChild('actions', { static: false }) actionsTemplate: TemplateRef<any>;
  metadataLeft: FormMeta = { groups: [] };
  metadataRight: FormMeta = { groups: [] };
  updating = false;
  tableConfig: TableConfig;

  selectedContract?: Contract;
  filteredContracts: Contract[] = [];

  confirmSubscription: Subscription;
  fieldSubScription: Subscription;

  constructor(
    private datePipe: SafeDatePipe,
    public dialog: DialogRef,
    private decimalPipe: DecimalPipe,
    public config: DialogConfig
  ) {}

  ngAfterViewInit(): void {
    this.tableConfig = CUSTOMER_PROGRESS_SK_INFO_DIALOG_CONTRACTS_TABLE_CONFIG(this.statusTemplate, this.actionsTemplate, (date) =>
      this.datePipe.transform(date, 'yyyy/MM/dd (E)'),
    );
  }
  selectContract(contract: Contract) {
    this.selectedContract = contract;
  }
  resetContractSelection() {
    this.selectedContract = null;
  }

  ngOnInit() {
    if(_.isArray(this.config.data.contracts)) {
      this.setFilteredContracts(this.config.data.contracts);
    }
  }

  setFilteredContracts(contracts: Contract[]) {
    // 該当enterpriseの有効な「AG_人材紹介」の契約を抽出
    // dynamicData.contractClassification === 'AG_人材紹介'
    this.filteredContracts = contracts.filter(
        c => c.dynamicData.contractClassification === 'AG_人材紹介' &&
              c.dynamicData.status === '有効'
      ).map(c => {
        // フィー一覧設定
        c.dynamicData.feeSummary = this.makeFeeSummary(c);
        return c;
      });
  }

  ngOnDestroy() {
    if (this.fieldSubScription) {
      this.fieldSubScription.unsubscribe();
    }
    if (this.confirmSubscription) {
      this.confirmSubscription.unsubscribe();
    }
  }

  close(): void {
    this.dialog.close();
  }

  private makeFeeSummary(contract:Contract):string {
    return [
      contract && contract.dynamicData.fee1Price
        ? `${this.decimalPipe.transform(contract.dynamicData.fee1Price)}\nフィー規定備考：${contract.dynamicData.fee1Remarks ? contract.dynamicData.fee1Remarks : ''}`
        : '',
      contract && contract.dynamicData.fee2Price
        ? `${this.decimalPipe.transform(contract.dynamicData.fee2Price)}\nフィー規定備考：${contract.dynamicData.fee2Remarks ? contract.dynamicData.fee2Remarks : ''}`
        : '',
      contract && contract.dynamicData.fee3Price
        ? `${this.decimalPipe.transform(contract.dynamicData.fee3Price)}\nフィー規定備考：${contract.dynamicData.fee3Remarks ? contract.dynamicData.fee3Remarks : ''}`
        : '',
      contract && contract.dynamicData.fee4Price
        ? `${this.decimalPipe.transform(contract.dynamicData.fee4Price)}\nフィー規定備考：${contract.dynamicData.fee4Remarks ? contract.dynamicData.fee4Remarks : ''}`
        : '',
      contract && contract.dynamicData.fee5Price
        ? `${this.decimalPipe.transform(contract.dynamicData.fee5Price)}\nフィー規定備考：${contract.dynamicData.fee5Remarks ? contract.dynamicData.fee5Remarks : ''}`
        : '',
    ]
      .filter((v) => !!v)
      .join('\n\n');
  }
}
